import { render, staticRenderFns } from "./EmergencyContactDetails.vue?vue&type=template&id=66a1d336"
import script from "./EmergencyContactDetails.vue?vue&type=script&lang=js"
export * from "./EmergencyContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports